import React from "react";
import PromoCodesList from "../promo-codes/list";
import PromoCodesForm from "../promo-codes/form";

export const AmbassadorCodes = () => (
  <PromoCodesList variant="ambassador" />
);

export const AmbassadorCodesForm = () => (
  <PromoCodesForm variant="ambassador" />
);
